import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import { getCollectionArrangements } from '../../../actions/collection';
import ArrangementsList from '../Common/ArrangementsList.jsx';


const CollectionArrangements = ({ getCollectionArrangements }) => {
  return <ArrangementsList loadListFromServer={ getCollectionArrangements }/>
}

CollectionArrangements.propTypes = {
  getCollectionArrangements: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    listCount: state.collection.listCount,
  }
};

export default compose(
  connect(null, { getCollectionArrangements }),
  LoginRequired,
  Page,
)(CollectionArrangements);

